'use client';

import type { ReactNode } from 'react';

type SettingsToolbarProps = {
  /** Search control, bounded to the prototype's 420px filter width. */
  search?: ReactNode;
  /** Filter/secondary controls, left-aligned after the search field. */
  filters?: ReactNode;
  /** Primary action(s), pushed to the right edge. */
  actions?: ReactNode;
  /** Figma's 417px Search & Filter field on the Users and Markets tables, instead of 320px. */
  wideSearch?: boolean;
  className?: string;
};

/**
 * The row above a settings table — the prototype's `.tbl-head`: a search field
 * that grows to at most 420px, then secondary controls, then the primary action
 * pinned right.
 */
export const SettingsToolbar = ({
  search,
  filters,
  actions,
  wideSearch = false,
  className,
}: SettingsToolbarProps) => (
  <div
    data-lula-ds=""
    className={`flex flex-wrap items-center gap-space-8 pb-space-16 font-sans${
      className ? ` ${className}` : ''
    }`}
  >
    {search && (
      <div
        className={`min-w-0 flex-1 basis-[16rem] ${
          wideSearch ? 'md:max-w-[26.0625rem]' : 'md:max-w-[20rem]'
        }`}
      >
        {search}
      </div>
    )}
    {filters}
    {actions && <div className="flex shrink-0 items-center gap-space-8 md:ml-auto">{actions}</div>}
  </div>
);

export default SettingsToolbar;
